import { useEffect, useRef } from 'react';

export const useBarcodeScanner = (options: {
  validate: (value: string) => boolean;
  onScan: (value: string) => void;
  onError: (value: string) => void;
  handlePaste: boolean;
}) => {
  const { validate, onScan, onError, handlePaste } = options;
  const scannedCode = useRef('');
  const lastInput = useRef<number>(Date.now());

  useEffect(() => {
    const keydownListener = (e: KeyboardEvent) => {
      if (scannedCode.current.length && Date.now() - lastInput.current > 2000) {
        console.log(`reset manual input: ${scannedCode.current}`);
        scannedCode.current = '';
      }

      if (e.key === 'Enter') {
        if (!scannedCode.current) {
          return;
        }
        if (!validate(scannedCode.current)) {
          console.log(`Invalid value: ${scannedCode.current}`);
          onError(scannedCode.current);
          scannedCode.current = '';
          return;
        }
        onScan(scannedCode.current);
        scannedCode.current = '';
        return;
      }

      scannedCode.current = scannedCode.current + e.key;
      lastInput.current = Date.now();

      // console.log(scanInput.current);
    };

    const pasteListener = (e: ClipboardEvent) => {
      const data = e.clipboardData?.getData('text');
      if (!data) {
        console.log('Data is empty');
        return;
      }
      if (!validate(data)) {
        console.log(`Invalid value: ${data}`);
        onError(data);
        return;
      }
      onScan(data);
    };

    document.addEventListener('keydown', keydownListener);

    if (handlePaste) {
      document.addEventListener('paste', pasteListener);
    }
    return () => {
      document.removeEventListener('keydown', keydownListener);

      if (handlePaste) {
        document.removeEventListener('paste', pasteListener);
      }
    };
  }, [validate, onScan, onError, handlePaste]);
};
